import React from 'react';
import { motion } from 'framer-motion';
import RentalHeroImage from './RentalHeroImage';

export default function RentalHero() {
  return (
    <div className="relative h-screen">
      {/* Full-screen image container */}
      <div className="absolute inset-0">
        <RentalHeroImage />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/60" />
      </div>

      {/* Content overlay */}
      <div className="relative z-10 h-screen flex flex-col items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-center"
        >
          <div className="bg-white/95 backdrop-blur-sm px-8 py-6 rounded-2xl shadow-xl">
            <h1 className="text-4xl md:text-6xl font-black text-gray-900">
              BENNYS PØLSEVOGN
              <span className="block text-red-600 mt-2">
                – NU MED HJUL!
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 font-medium mt-2">
              (JA, VI FANDT DEM TILBAGE)
            </p>
          </div>
        </motion.div>
      </div>

      {/* Bottom fade gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white via-white/90 to-transparent" />
    </div>
  );
}